import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Lock, Mail, Loader2 } from "lucide-react";

export default function AdminLogin() {
  const [email, setEmail] = useState("admin@kkassociates.in");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  if (localStorage.getItem("kk_admin_token")) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("kk_admin_token", data.access_token);
      localStorage.setItem("kk_admin_user", JSON.stringify(data.user));
      nav("/admin");
    } catch (e) {
      const detail = e.response?.data?.detail;
      setErr(typeof detail === "string" ? detail : "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  const input =
    "w-full pl-11 pr-4 py-3 rounded-xl border border-slate-200 bg-white text-sm text-slate-900 placeholder:text-slate-400 focus:border-blue-500 focus:outline-none";

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-white">
      <div className="hidden lg:flex relative bg-slate-950 text-white p-10 items-end overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1687197180710-b2b9484a3c5f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBmaW5hbmNlJTIwYnVzaW5lc3MlMjBhYnN0cmFjdCUyMGJsdWV8ZW58MHx8fHwxNzgzNzQ2ODA0fDA&ixlib=rb-4.1.0&q=85"
          alt="Abstract blue"
          className="absolute inset-0 w-full h-full object-cover opacity-40"
        />
        <div className="relative">
          <div className="h-display text-5xl">KK Associates</div>
          <div className="mt-2 text-blue-200 tracking-widest text-xs uppercase">Admin Console</div>
        </div>
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-md">
          <h1 className="h-display text-4xl text-slate-900">Sign in</h1>
          <p className="mt-2 text-slate-600 text-sm">Manage services, enquiries and appointments.</p>
          <div className="mt-8 space-y-4">
            <div className="relative">
              <Mail size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
              <input required type="email" data-testid="admin-email" className={input} placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div className="relative">
              <Lock size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
              <input required type="password" data-testid="admin-password" className={input} placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
            </div>
          </div>
          {err && <div data-testid="admin-error" className="mt-4 text-sm text-red-600">{err}</div>}
          <button
            disabled={loading}
            data-testid="admin-login-submit"
            className="btn-hover mt-6 w-full inline-flex items-center justify-center gap-2 rounded-full bg-slate-900 text-white px-6 py-3 text-sm font-medium hover:bg-blue-700 disabled:opacity-60"
          >
            {loading ? <><Loader2 size={16} className="animate-spin" /> Signing in…</> : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
